// extracted by mini-css-extract-plugin
export default {"quickAction":"kVHLPas"};